import request from '../../axios';
import {
  ISubBrandAdvertisementsResponse,
  ISubBrandAdvertisementsResponsePayload,
} from './types';

interface IProps {
  pageParam: number;
  payload?: ISubBrandAdvertisementsResponsePayload;
}

export const getSubBrandAdvertisementsList = async ({
  pageParam,
  payload,
}: IProps) => {
  // Extract `enabled` from the payload (if it exists) because it's just for the React Query
  const {enabled, subBrandGuid, ...rest} = payload ?? {};

  const {data}: {data: ISubBrandAdvertisementsResponse} = await request.get(
    `/api/v2/store/list-sub-brand-advertisement/sub-brand/${subBrandGuid}`,
    {
      params: {
        page: pageParam,
        page_size: payload?.page_size ?? 10,
        ...rest,
      },
    },
  );

  return data;
};
